import { IAlertGroup, IUser } from "./types";

// Define resources and actions separately
export type Resource =
  | "bulletin"
  | "users"
  | "admins"
  | "bulletin_sharing"
  | "group";
export type Action =
  | "view"
  | "create"
  | "edit"
  | "flag"
  | "share"
  | "manage"
  | "bypass"
  | "moderate";

// Define permission keys that map directly to the boolean fields in IAlertGroup
export type PermissionKey =
  | "bypass_moderation"
  | "moderate_bulletin_admittance"
  | "manage_members"
  | "manage_admins"
  | "flag_bulletin"
  | "manage_group";

// Map permission strings to IAlertGroup boolean fields
const PERMISSION_MAP: Record<string, string> = {
  "bypass:moderation": "bypass_moderation",
  "manage:bulletin_sharing": "moderate_bulletin_admittance",
  "manage:users": "manage_members",
  "manage:admins": "manage_admins",
  "flag:bulletin": "flag_bulletin",
  "manage:group": "manage_group",
  "view:group": "view_group",
};

/**
 * Check if user has permission to perform a specific action on a resource
 * @param user Current user object
 * @param action Action to perform (view, create, edit, etc.)
 * @param resource Resource to act upon (bulletin, users, etc.)
 * @param groups List of alert groups the user belongs to
 * @param groupId ID of the group to check permissions for (if applicable)
 * @returns boolean indicating whether permission is granted
 */
export const checkPermission = (
  user: IUser | null,
  action: Action,
  resource: Resource,
  groups: IAlertGroup[],
  groupId?: number,
): boolean => {
  // If user is not logged in, return false
  if (!user) return false;
  // If user is a global admin, they have all permissions
  if (user.is_admin) return true;

  // Combine action and resource to form permission string
  const permissionString = `${action}:${resource}`;
  const permissionKey = PERMISSION_MAP[permissionString];
  // console.log("permissionKey:", permissionKey);
  // console.log("permissionString:", permissionString);

  // Check if the action is related to a specific group
  if (groupId) {
    // Find the user's membership in the specified group
    const userGroup = groups.find((group) => group.id === groupId);
    if (!userGroup) {
      return false;
    }
    if (permissionKey === "view_group") {
      return true;
    } // check for manage_group permission
    if (permissionKey === "manage_group") {
      return userGroup.manage_group;
    }
    if (permissionKey === "manage_members") {
      return userGroup.manage_members;
    }

    // Check if the user has the specific permission in this group
    if (permissionKey && userGroup[permissionKey]) {
      return true;
    }
    // if (
    //   permissionKey === "manage_admins" ||
    //   userGroup.role === "admin" ||
    //   userGroup.role === "owner"
    // ) {
    //   return userGroup.manage_admins;
    // }
  } else {
    // If checking view_group, user can view any group they belong to
    if (permissionKey === "view_group") {
      return groups.length > 0;
    }
    // Check if the user has this permission in any of their groups
    return groups.some((group) => {
      return permissionKey ? Boolean(group[permissionKey]) : false;
    });
  }

  return false;
};

export default checkPermission;
